import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledImage = styled.div`
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    background: linear-gradient(180deg, #ffb7b7 0%, #727272 100%),
        radial-gradient(60.91% 100% at 50% 0%, #ffd1d1 0%, #260000 100%),
        linear-gradient(127.43deg, #00ffff 0%, #ffffff 100%),
        radial-gradient(100.22% 100% at 70.57% 0%, #ff0000 0%, #00ffe0 100%),
        linear-gradient(64.82deg, #dbff00 0%, #3300ff 100%);
    background-blend-mode: screen, overlay, color-burn, color-dodge, normal;

    & img {
        position: absolute;
        inset: 0;
        box-sizing: border-box;
        padding: 0;
        border: none;
        margin: auto;
        display: block;
        width: 0;
        height: 0;
        top: 0;
        left: 0;
        min-width: 100%;
        max-width: 100%;
        min-height: 100%;
        max-height: 100%;
        object-fit: cover;
        filter: none;
        background-size: cover;
        background-image: none;
        background-position: 0 0;
    }
`;

export const StyledRatio = styled.div<{ ratio?: number }>`
    box-sizing: border-box;
    padding-top: 38%;

    ${media.sm`
    padding-top: 26%;
  `}

    ${media.md`
    padding-top: 19%;
  `}
`;

export const VideoInnerWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
